import  Head from "next/head";
import ContentPanes, { ContentPaneTypes } from "../components/ContentPanes";
import Layout from "../components/Layout";
//import styles from './upcoming-online-sessions.module.scss'


import { MenuId } from "../components/Header";




import EmailSignupBanner from "../components/EmailSignupBanner";
import { Blockquote, Button, Center, Space, Text } from "@mantine/core";
import { JWHostedPlayer } from "../components/Video";
import { AspectBox } from "../components/AspectBox";
import router from "next/router";
import { useEffect, useState } from "react";
import { useRawUmberContext } from "../lib/rawumberprovider";

//export default function UpcomingSessions( {data} : InferGetServerSidePropsType<typeof getServerSideProps>)
export default function Online()

{    
    const { localizationInformation} = useRawUmberContext();

    
    function getVideoId()
    {
        let v = 'l2VEfR2p';

        if (localizationInformation)
        {
            switch (localizationInformation.CurrencyCode)
            {
                case 'USD':
                    v='pC6Iv2HT'
                    break;
                case "EUR":
                    v='aw1WLp0V'
                    break;
                default:
                    v='l2VEfR2p';
                    break;
            }
        }

        return v;
    }
    useEffect(()=>
    {
        setVideoId(getVideoId());
    }, [localizationInformation]);

    const [videoId, setVideoId] = useState(getVideoId());
        
    return( 
        <Layout menuId={MenuId.online}>


        <Head>
            <title>Raw Umber Subscription</title>
            <meta name="description" content="Livestreams, videos, reference images and other online learning material for artists of all levels"></meta>
        </Head>
        <div>
        <h1>Raw Umber Subscription</h1>
        <h2 style={{textAlign:'center'}}>A comprehensive collection of online learning and reference materials for artists of all levels</h2>
        <Blockquote color="yellow" cite="- Miriam Danar">
        <i>This is the best drawing instruction I’ve seen anywhere</i>
        </Blockquote>
        <div style={{display:'flex', flexDirection:'column', alignItems:'center'}}>
        <div style={{padding:10, borderStyle:'solid', borderRadius:10}}>
        <div style={{maxWidth:500, minWidth:400, borderRadius:'10px', overflow:'hidden'}}>
            
        <AspectBox width={16} height={9}>
        <JWHostedPlayer jwId={videoId} key='overview' loop={true} autostart={false} controls={true} mute={false}/>
        </AspectBox>
        </div>
        <div>Watch this overview to learn about our subscription</div>
        </div>
        </div>

        <Space h='md'/>
        <SubscribeButton/>
    <ContentPanes contentPanes={[ContentPaneTypes.onlineSessions,  ContentPaneTypes.playlists, ContentPaneTypes.videoSearch, ContentPaneTypes.imageSearch, ContentPaneTypes.threeDLibrary, ContentPaneTypes.subscribeNow, ContentPaneTypes.userImages]}/>

   
        <SubscribeButton/>

    <Blockquote color="yellow" cite="- Mike Sykes">
    <Text size="md">The perfect, challenging stimulus to develop and improve my own style of portrait and figure drawing [...] a super set of reference materials and videos to go back to.</Text>
    </Blockquote>
    
    <EmailSignupBanner/>
    </div>
    </Layout>  
    );
}

function SubscribeButton()
{
    function subscribe()
    {
        router.push("/subscribe");
    }

    return  <Center>
    <Button  color="lime" radius="md" size="xl" onClick={subscribe}>Subscribe now!</Button>
    </Center>
}